import {SessionItem} from "./SessionItem.js";

export class SessionHandler {

    public static DEFAULT_SESSION_KEY: string = "default";
    private _sessionMap = new Map<string, SessionItem>()
    private _selectSessionId = SessionHandler.DEFAULT_SESSION_KEY

    /**
     * 创建新会话
     * @param sessionId 会话id
     * @param sessionTitle 会话标题
     */
    public createSession(sessionId: string, sessionTitle: string) {

        const session: SessionItem = new SessionItem(sessionId)

        session.sessionTitle = sessionTitle
        this._sessionMap.set(sessionId, session)
        this._selectSessionId = sessionId

    }

    /**
     * 获取会话
     * @param key 会话id
     */
    public getSession(key: string) {
        if(this._sessionMap.has(key)) {
            return this._sessionMap.get(key)
        }
        return null
    }

    /**
     * 获取当前活动会话
     */
    public getActiveSession() {
        return this._sessionMap.get(this.selectSessionId)
    }


    get selectSessionId(): string{
        return this._selectSessionId;
    }

    //当前活动id
    set selectSessionId(id: string) {

        if(this._sessionMap.has(id)) {
            this._selectSessionId = id;
        }

    }

    /**
     * 获取全部session，可以绑定控件
     */
    get sessionMap(): Map<string, SessionItem> {
        return this._sessionMap;
    }
}